import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsOptimizeFieldConfigurationSchemeRoute: InvariantJiraRoute = {
	name: 'global-settings-optimize-field-configuration-scheme-view',
	path: '/jira/settings/issues/field-configuration-schemes/:fieldConfigurationSchemeId/optimize',
};
